/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./operation-result-types";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onNewMessage = /* GraphQL */ `subscription OnNewMessage($pk: String!) {
  onNewMessage(pk: $pk) {
    content
    g_user_id
    input_tokens
    msg_type
    output_tokens
    pk
    sender
    session_id
    sk
    user_response
    vault_user_form_id
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnNewMessageSubscriptionVariables,
  APITypes.OnNewMessageSubscription
>;
